import { Directive, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { UserStatsCategory } from "./user-stats-category";

@Directive() 
export abstract class UserStatsContainer {
    @Input({ required: true }) public username!: string;
    @Input({ required: true }) public statsCategory!: UserStatsCategory;
    @Input({ required: true }) public selectedCategory!: UserStatsCategory;

    public isVisible: boolean = false;
    protected isInitialized: boolean = false;

    public constructor(protected ponderDataClient: PonderDataClient) {

    }

    public ngOnInit(): void {
        this.ngOnChanges();
    }

    public ngOnChanges(): void {
        this.isVisible = (this.selectedCategory === this.statsCategory);
        
        if (this.isVisible && !this.isInitialized) {
            this.isInitialized = true;
            this.onInitialize();
        }
    }

    protected abstract onInitialize(): void;
}